var _defs, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMultipleActuation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    viewBox: "0 0 409.5 428.99999",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "295d54be1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 0.773438 L 408 0.773438 L 408 409.023438 L 1 409.023438 Z M 1 0.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ece6689a79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.5 206 L 409 206 L 409 428 L 204.5 428 Z M 204.5 206 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#295d54be1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7367f0",
    d: "M 204.296875 0.773438 C 91.617188 1.453125 0.714844 93.308594 1.394531 206.121094 C 2.074219 318.9375 93.933594 409.703125 206.746094 409.023438 C 260.226562 408.75 311.394531 387.523438 349.359375 349.828125 L 312.617188 313.085938 C 252.878906 373.097656 155.984375 373.234375 95.972656 313.628906 C 35.960938 254.023438 35.6875 156.859375 95.292969 96.984375 C 124.007812 68.132812 163.0625 51.9375 203.75 51.804688 C 244.167969 52.074219 282.679688 68.949219 310.441406 98.207031 L 254.78125 153.867188 L 407.878906 153.867188 L 407.878906 0.773438 L 347.183594 61.464844 C 309.351562 22.953125 257.777344 1.179688 203.75 0.773438 Z M 204.296875 0.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ece6689a79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d15794",
    d: "M 253.007812 206.097656 L 360.496094 206.097656 C 387.269531 206.097656 409 227.820312 409 254.585938 L 409 378.914062 C 409 405.679688 387.269531 427.402344 360.496094 427.402344 L 253.007812 427.402344 C 226.230469 427.402344 204.5 405.679688 204.5 378.914062 L 204.5 254.585938 C 204.5 227.820312 226.230469 206.097656 253.007812 206.097656 Z M 253.007812 206.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 318.390625 302.980469 L 354.382812 302.980469 L 354.382812 324.023438 L 318.390625 324.023438 L 318.390625 365.046875 L 296.078125 365.046875 L 296.078125 324.023438 L 259.796875 324.023438 L 259.796875 302.980469 L 295.980469 302.980469 L 295.980469 264.671875 L 318.292969 264.671875 L 318.292969 302.980469 Z M 318.390625 302.980469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMultipleActuation);
export default __webpack_public_path__ + "static/media/add_multiple_actuation.98e5cdcf32037d5b7c4ba9f557303b2f.svg";
export { ForwardRef as ReactComponent };